import { configureStore } from "@reduxjs/toolkit";
import { ThunkAction } from "redux-thunk";
import { AnyAction } from "redux";
import authentication from "../reducers/authentication";
import common from "../reducers/common";
import config from "../reducers/config";
import integrations from "../reducers/integrations";
import ipAddresses from "../reducers/ipAddresses";
import properties from "../reducers/properties";
import templates from "../reducers/templates";
import userprofiles from "../reducers/userprofiles";
import yardidata from "../reducers/yardidata";
import queueManagement from "../reducers/queueManagement";
import configuration from "../reducers/configuration";
import pythonSettings from "../reducers/pythonSettings";
import diagnostics from "../reducers/diagnostics";
import marketData from "../reducers/marketData";
import templateExclude from "../reducers/templateExclude";
import permissions from "../reducers/permissions";
import vts from "../reducers/vts";
import news from "../reducers/news";
import iex from "../reducers/iex";
import argus from "../reducers/argus";

export const store = configureStore({
    reducer: {
        authentication,
        common,
        config,
        integrations,
        ipAddresses,
        properties,
        templates,
        userprofiles,
        yardidata,
        queueManagement,
        configuration,
        pythonSettings,
        diagnostics,
        marketData,
        templateExclude,
        permissions,
        vts,
        news,
        iex,
        argus,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    AnyAction
>;
